import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};

var ArrowOneCircle = function ArrowOneCircle(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return React.createElement('svg', {
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    d: 'M4.28716 13.17C4.85188 16.9225 8.08966 19.7999 11.9998 19.7999C16.3077 19.7999 19.7998 16.3079 19.7998 12C19.7998 7.69219 16.3077 4.2002 11.9998 4.2002C8.8018 4.2002 6.0523 6.1252 4.84876 8.8801',
    stroke: color,
    strokeWidth: '1.44',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement('path', {
    d: 'M8.09961 8.88039H4.66761C4.60615 8.88039 4.54529 8.86829 4.48851 8.84477C4.43173 8.82125 4.38014 8.78678 4.33668 8.74332C4.29323 8.69986 4.25875 8.64827 4.23523 8.59149C4.21171 8.53471 4.19961 8.47386 4.19961 8.4124V4.98047',
    stroke: color,
    strokeWidth: '1.44',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

ArrowOneCircle.propTypes = propTypes;
export default ArrowOneCircle;